// extracted by mini-css-extract-plugin
export var webContainer = "mobileWeb-module--webContainer--zLc3o";
export var web0 = "mobileWeb-module--web0--cUibD";
export var web1 = "mobileWeb-module--web1--JnwZi";
export var textContainer = "mobileWeb-module--textContainer--9kfRo";